<app-topbar></app-topbar>
<div class="container mr-top-40">
    <h1 class="mainhdng mr-bttm-30 mb-3">Users</h1>
	<div class="descript mb-3" *ngIf = "userList?.length <= 0">Explanation about what is a User for the Apps</div>
	 <div class="descript mb-3" *ngIf = "userList?.length > 0">These users have access to manage Nuflorist applications.</div>
    <div class="add_new_store float-md-right text-md-right mb-3 descript tooltipuser"  data-toggle="modal" data-target="#editAdminUser" (click) ="addAdmin()" *ngIf = "userList?.length > 0" title="Regular user must be a different email from an Admin user">
      <img src="assets/images/addanothersrore.png" class="pd-rt-10"> <span class="rmbrme adau"> Add New User</span>
    </div>
</div>

<div class="container cntremptyscrn usermix">
    <div class="h-80 justify-content-center align-items-center">
        <div class="table-responsive">
			<div class="emptyusersdiv" *ngIf = "userList?.length <= 0">
				<div class="emptyusersdivinner">
					<h4>You don’t have Users for the apps to see yet</h4>
					<p>Click below to start adding a user</p>
					<button class="boxbluebuttn" data-toggle="modal" data-target="#editAdminUser" (click) ="addAdmin()">Add User</button>
				</div>
			</div>
            <!-- {{userList | json}} -->
			<div class="table-borderless roundbor mb2020">
            <table *ngIf = "userList?.length > 0" class="table cstm_tble_cs NewTblBrdr">
            <thead>
            <tr class="active thead">
                <th style="width:30%">Full Name</th>
                <th style="width:30%">Email</th>
                <th style="width:30%">Access</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor ="let user of userList" class="bodwithspace">
                <td><p class="boxpara">{{user.first_name}} {{user.last_name}}</p></td>
                <td><p class="boxpara">{{user.email}}</p></td>
                <td><p class="boxpara">{{user.product_name}}</p></td>
                <td>
                   <a href="javascript:void(0)" data-toggle="modal" data-target="#editAdminUser" (click) = "openModal(user.id,user.first_name,user.last_name,user.email)"><i class="fa fa-pencil" aria-hidden="true"></i></a> | 
                   <a href="javascript:void(0)" data-toggle="modal" data-target="#deleteuser" (click) = "deleteopenModal(user.id)"><i class="fa fa-trash" aria-hidden="true"></i></a>
               </td>
            </tr>
            </tbody>
            </table>
			</div>
         </div>
    </div>
</div>

<!---Delete user--->
<div class="modal fade in centerModalNew" id="deleteuser" >
   <div class="modal-dialog chngnmbrpopup">
      <div class="modal-content">
         <!-- Modal body -->
         <div class="modal-body changenumberbody">
            <div class="common billingform changenumber">
               <form [formGroup]="admin_user_form" (ngSubmit)="admin_user_delete()" id="admin_user_frm">
                  <h6 class="sucssheading clrgry text-left">Delete</h6>
                  <p>Are you sure you want to delete the user ? </p>
                 
                   <input type="hidden" name="" ngClass="form-control" id="delete_user_id" value="{{delete_user_id}}">
                 
                  <span class="inputValidation">{{emailError}}</span>
                <div class="common changenumberbttn text-left" style="margin-top:10px;">
                     <button class="savebttn">Yes</button>
                     <button class="cancelbttn cancelbttn_delete" data-dismiss="modal">No</button>
                  </div>
                  <div class="common text-success sccsmsgdiv" >{{emailUpdate}}</div>
                  
               </form>
            </div>
         </div>
      </div>
   </div>
</div>
<!---Delete user--->
<!-- Change Email Modal -->
<div class="modal fade in centerModalNew" id="editAdminUser" >
    <div class="modal-dialog chngnmbrpopup">
       <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body changenumberbody" id="editAdmin">
             <div class="common billingform changenumber">
                <form [formGroup]="admin_user_form" (ngSubmit)="admin_user_submit()" id="admin_user_frm">
                   <h6 class="sucssheading clrgry text-left">{{userFormTitle}}</h6>
                   <div class="form-group">
                    <input type="text" name="" ngClass="form-control" placeholder="Enter First Name" id="enterFName" formControlName="firstname" (keyup) ="clearError()">
                    <!-- <span class="inputValidation">{{ first_nameError }}</span> -->
                    <div *ngIf="adminFormSubmitted && admin_user_f.firstname.invalid">
                        <span class="inputValidation" *ngIf="admin_user_f.firstname.errors.required">First Name is required.</span>
                        <span class="inputValidation" *ngIf="admin_user_f.firstname.errors.minlength">First Name should be 3 character.</span>
                    </div>
                 </div>
                 <div class="form-group">
                    <input type="text" name="" ngClass="form-control" placeholder="Enter Last Name" id="enterLName" formControlName="lastname" (keyup) ="clearError()">
                    <div *ngIf="adminFormSubmitted && admin_user_f.lastname.invalid">
                        <span class="inputValidation" *ngIf="admin_user_f.lastname.errors.required">Last Name is required.</span>
                    </div>
                 </div>
                   <div class="form-group">
                      <input type="email" name="" ngClass="form-control" placeholder="Enter Email" id="enterEmail" formControlName="email" (keyup) ="clearError()">
                      <div *ngIf="adminFormSubmitted && admin_user_f.email.invalid">
                        <span class="inputValidation" *ngIf="admin_user_f.email.errors.required">Email is required.</span>
                        <span class="inputValidation" *ngIf="admin_user_f.email.errors.email">Email is not valid.</span>
                        
                    </div>
                    <span class="inputValidation">{{emailError}}</span>
                   </div>
                   <div class="common changenumberbttn text-left">
                      <button class="savebttn">{{userFormBtn}}</button>
                      <button class="cancelbttn cancelbttn_email" data-dismiss="modal">Close</button>
                   </div>
                   
                   <div class="common text-success sccsmsgdiv" >{{emailUpdate}}</div>
                </form>
             </div>
          </div>
       </div>
    </div>
 </div>



<!--Sub admin users Start-->
<div class="container mr-top-40">
    <h1 class="mainhdng mb-3">Admin Users</h1>
	<div class="descript mb-3" *ngIf = "userList1?.length <= 0">Explanation about what is a Sub Admin Users</div>
	 <div class="descript mb-3" *ngIf = "userList1?.length > 0">Admin user has the ability to manage Nuflorist Accounts including Products, Subscriptions, Payments and Billing.</div>
	 <div class="add_new_store float-md-right text-md-right mb-3 descript tooltipuser"  data-toggle="modal" data-target="#editAdminUser1" (click) ="addAdmin1()" *ngIf = "userList1?.length > 0" title="Admin user cannot be the same email as a regular user">
      <img src="assets/images/addanothersrore.png" class="pd-rt-10"> <span class="rmbrme adau"> Add New User</span>
    </div>
    <!--<div class="add_new_store float-right w-100 text-right mb-3"  data-toggle="modal" data-target="#editAdminUser1" (click) ="addAdmin1()">
      <img src="assets/images/addstore.png" class="pd-rt-10"> <span class="rmbrme adau"> Add Sub Admin</span>
    </div>-->
</div>
<div class="container cntremptyscrn usermix">
    <div class="h-80 justify-content-center align-items-center">
        <div class="table-responsive">
			<div class="emptyusersdiv mb2020" *ngIf = "userList1?.length <= 0">
				<div class="emptyusersdivinner">
					<h4>You don’t have Sub Admin users to see yet</h4>
					<p>Click below to start adding a Sub Admin user</p>
					<button class="boxbluebuttn" data-toggle="modal" data-target="#editAdminUser1" (click) ="addAdmin1()">Add User</button>
				</div>
			</div>
            <!-- {{userList | json}} -->
			<div class="table-borderless roundbor mb2020">
            <table *ngIf = "userList1?.length > 0" class="table cstm_tble_cs NewTblBrdr">
            <thead>
            <tr class="active thead">
                <th style="width:30%">Full Name</th>
                <th style="width:30%">Email</th>
                <th style="width:30%">Access</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
			<tr *ngFor ="let user of userList1" class="bodwithspace">
               
                <td style="vertical-align:middle;"><p class="boxpara">{{user.first_name}} {{user.last_name}}</p></td>
                <td style="vertical-align:middle;"><p class="boxpara">{{user.email}}</p></td>
				<td style="vertical-align:middle;"><p class="boxpara">{{user.permissions}}</p></td>
                <td style="vertical-align:middle;"><a href="javascript:void(0)" data-toggle="modal" data-target="#editAdminUser1" (click) = "openModal1(user.id,user.first_name,user.last_name,user.email,user.id)"><i class="fa fa-pencil" aria-hidden="true"></i></a></td>
            </tr>
            </tbody>
            </table>
			</div>
         </div>
    </div>
</div>
<!-- Change Email Modal -->
<div class="modal fade in centerModalNew" id="editAdminUser1" >
    <div class="modal-dialog chngnmbrpopup">
       <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body changenumberbody" id="editAdmin1">
             <div class="common billingform changenumber pt26">
                <form [formGroup]="admin_user_form1" (ngSubmit)="admin_user_submit1()" id="admin_user_frm1">
                   <h6 class="sucssheading clrgry text-left text-dark mb-sm-5 mb-3">{{userFormTitle}}</h6>
                   <div class="form-group mb-4">
                    <input type="text" name="" ngClass="form-control" placeholder="Enter First Name" id="enterFName1" formControlName="firstname" (keyup) ="clearError()">
                    <!-- <span class="inputValidation">{{ first_nameError }}</span> -->
                    <div *ngIf="adminFormSubmitted && admin_user_f1.firstname.invalid">
                        <span class="inputValidation" *ngIf="admin_user_f1.firstname.errors.required">First Name is required.</span>
                        <span class="inputValidation" *ngIf="admin_user_f1.firstname.errors.minlength">First Name should be 3 character.</span>
                    </div>
                 </div>
                 <div class="form-group mb-4">
                    <input type="text" name="" ngClass="form-control" placeholder="Enter Last Name" id="enterLName1" formControlName="lastname" (keyup) ="clearError()">
                    <div *ngIf="adminFormSubmitted && admin_user_f1.lastname.invalid">
                        <span class="inputValidation" *ngIf="admin_user_f1.lastname.errors.required">Last Name is required.</span>
                    </div>
                 </div>
                   <div class="form-group mb-4">
                      <input type="email" name="" ngClass="form-control" placeholder="Enter Email" id="enterEmail1" formControlName="email" (keyup) ="clearError()">
                      <div *ngIf="adminFormSubmitted && admin_user_f1.email.invalid">
                        <span class="inputValidation" *ngIf="admin_user_f1.email.errors.required">Email is required.</span>
                        <span class="inputValidation" *ngIf="admin_user_f1.email.errors.email">Email is not valid.</span>
                        
                    </div>
                    <span class="inputValidation">{{emailError}}</span>
                   </div>

                   <label class="sucssheading text-left mb-3 permstyle">Permissions</label>
                   <div class="container p-0 mb-5">
                     <div class="row form-group">
                       <div class="col-md-6 col-12">
                          <div class="form-check mb-1">
                        <input class="form-check-input" type="checkbox" value="" id="permission1"  value="checkout" (change)="onChange($event.target.checked, $event.target.value,'Buy Subscriptions')" formGroupName="permissions" [attr.checked] ="checkPermission('checkout')" >
                        <label class="form-check-label optstyle" for="permission1">
                           Buy Subscriptions
                        </label>
                     </div>
                       </div>
                       <div class="col-md-6 col-12">
                         <div class="form-check mb-1">
                        <input class="form-check-input" type="checkbox" value="" id="permission2"  value="company-store" (change)="onChange($event.target.checked, $event.target.value,'Companies & Stores')" formGroupName="permissions" [attr.checked] ="checkPermission('company-store')">
                        <label class="form-check-label" for="permission2">
                           Companies & Stores
                        </label>
                     </div>
                       </div>
                       <div class="col-md-6 col-12">
                         <div class="form-check mb-1">
                        <input class="form-check-input" type="checkbox" value="" id="permission3"  value="subscriptions" (change)="onChange($event.target.checked, $event.target.value,'Products & Subscriptions')" [attr.checked] ="checkPermission('subscriptions')">
                        <label class="form-check-label" for="permission3">
                           Products & Subscriptions
                        </label>
                     </div>
                       </div>
                       <div class="col-md-6 col-12">
                         <div class="form-check mb-1">
                        <input class="form-check-input" type="checkbox" value="" id="permission4"  value="users" (change)="onChange($event.target.checked, $event.target.value,'App Users')" [attr.checked] ="checkPermission('users')">
                        <label class="form-check-label" for="permission4">
                           App Users
                        </label>
                     </div>
                       </div>
                       <div class="col-md-6 col-12">
                         <div class="form-check mb-1">
                        <input class="form-check-input" type="checkbox" value="" id="permission5"  value="subadmin" (change)="onChange($event.target.checked, $event.target.value,'Sub Admin')" [attr.checked] ="checkPermission('subadmin')">
                        <label class="form-check-label" for="permission5">
                          Sub Admin
                        </label>
                     </div>
                       </div>
                     </div>
                   </div>


                     
                  

                   <div class="common changenumberbttn text-sm-left mt-sm-3 mt-0 text-center">
                      <button class="savebttn savebtn2">{{userFormBtn}}</button>
                      <button class="cancelbttn cancelbttn_email1 mt-sm-0" data-dismiss="modal">Close</button>
                   </div>
                   
                   <div class="common text-success sccsmsgdiv" >{{emailUpdate}}</div>
                </form>
             </div>
          </div>
       </div>
    </div>
 </div>
<!--Sub admin users End-->